import React, { forwardRef } from "react";

import { StoreDirectionsMapComponent } from "./storeDirectionsMap.component";

const StoreDirectionsMap = forwardRef<HTMLDivElement>((_, ref) => {
    return <StoreDirectionsMapComponent ref={ref} />;
});

export { StoreDirectionsMap };
